// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/config';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Sliders from './pages/Sliders';
import News from './pages/News';
import Notifications from './pages/Notifications';
import Gallery from './pages/Gallery';
import Faculty from './pages/Faculty';
import Events from './pages/Events';
import Courses from './pages/Courses';
import Settings from './pages/Settings';
import Testimonials from './pages/Testimonials';
import Departments from './pages/Departments';
import Contact from './pages/Contact';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={user ? <Layout /> : <Navigate to="/login" />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="sliders" element={<Sliders />} />
          <Route path="news" element={<News />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="faculty" element={<Faculty />} />
          <Route path="events" element={<Events />} />
          <Route path="courses" element={<Courses />} />
          <Route path="settings" element={<Settings />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="departments" element={<Departments />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;